const $ = require('jquery');
import {setElementsFromScope} from "../../utilities/selectorHelpers";
import render from "../../utilities/render";
const modalHtml = require("../../sharedHtml/modal.html");
const modalBodyHtml = require("./html/modalBody.html");
import {keyDefaultFalseOption} from '../../utilities/general';

const elementsMap = {
  closeBtn: ".top-close-btn"
};

export default function ErrorModal(options={}){
  const self = this;
  const els = {};
  let errorModal;

  self.init = function(){
    buildHtml();
    setElements();
    bindElements();
  };

  self.showModal = function() {
    showModal();
  };

  self.hideModal = function() {
    hideModal();
  };

  self.setErrors = function(data={}) {
    const errorBody = $(buildErrorModalBody(data));
    errorModal.find('.modal-body').html(errorBody);
  };

  function buildErrorModalBody(data={}) {
    return render(
      modalBodyHtml,
      {
        errorTitle: data.errorTitle || options.errorTitle,
        errorDescription: data.errorDescription || options.errorDescription
      }
    );
  }

  function buildHtml(){
    // Set Options
    const modalDefaults = {
      backdrop:'static', 
      keyboard: false,
      show: false
    };

    // Build Modal
    errorModal = $(render(
      modalHtml,
      {
        title: 'Sorry...',
        leftAlignTitle: keyDefaultFalseOption(options, "errorModalLeftAlignTitle"),
        body: buildErrorModalBody(),
        topCloseBtn: keyDefaultFalseOption(options, "errorModalTopClose"),
        footerBtns: `
          <a href="#" class="base-btn v2-btn purple-btn modal-auto-hide">Close</a>
        `
      }
    ));

    // Apply Options
    errorModal.modal(modalDefaults);
  }

  function setElements(){
    setElementsFromScope(els, elementsMap, errorModal);
  }

  function bindElements(){
    els.closeBtn.on('click', onCloseClick);
  }

  function showModal() {
    errorModal.modal("show");
  }

  function hideModal() {
    errorModal.modal('hide');
  }

  function onCloseClick(e){
    e.preventDefault();
    const shouldClose = options.shouldCloseModal && options.shouldCloseModal();
    if (shouldClose !== false) {
      hideModal();
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/ErrorModal/ErrorModal.js